import { IcFilter } from '@assets/icons/24x24';
import { HStack, Icon, Separator, Text, VStack } from '@chakra-ui/react';
import CustomChipList from '@components/common/inputs/CustomChipList';
import { ScrollArea } from '@components/ui/ScrollArea';
import { FormattedMessage, useIntl } from 'react-intl';

import Filters from '../filters/Filters';
import Header from '../Header';
import { SortEnum, useMonitoringContext } from '../MonitoringContext';
import CriticalityList from './CriticalityList';
import TypeList from './TypeList';

export default function MonitoringList() {
  const { formatMessage } = useIntl();

  const { state, setOpen, setSort, numberOfChanges, filteredSensorOrSubSensorInfoList } = useMonitoringContext();

  const chipOptions = Object.values(SortEnum).map((key) => ({
    label: formatMessage({ id: `components.monitoring.${key}` }),
    value: key,
  }));

  return (
    <HStack gap={0} width="100%" height="100%" userSelect="none">
      <Filters />
      <VStack backgroundColor="neutral.900" width="100%" height="100%" flex={1} minWidth={0} gap={0}>
        <HStack
          gap={0.25}
          width="100%"
          height="58px"
          borderBottom="2px solid"
          borderColor="neutral.black"
          backgroundColor="neutral.850"
          flexShrink={0}
          separator={<Separator orientation="vertical" size="md" borderColor="neutral.black" />}
        >
          {!state.open && (
            <HStack
              gap={1}
              paddingX={1.5}
              marginX={3}
              border="2px solid"
              borderColor="blue"
              cursor="pointer"
              onClick={() => setOpen(true)}
            >
              <Icon as={IcFilter} color="neutral.300" boxSize="24px" />
              <Text>
                <FormattedMessage id="components.monitoring.filter.title" />
              </Text>
              <Text fontWeight="medium" color="skyBlue">
                {numberOfChanges}
              </Text>
            </HStack>
          )}
          <Text fontWeight="medium" color="neutral.200" paddingX={3} flexShrink={0}>
            <FormattedMessage id="global.result" values={{ count: filteredSensorOrSubSensorInfoList.length }} />
          </Text>
          <Header />
          <HStack gap={1} marginLeft="auto" paddingX={3} flexShrink={0}>
            <Text color="neutral.200">
              <FormattedMessage id="components.monitoring.header.sort" />
            </Text>
            <CustomChipList
              availableOptions={chipOptions}
              selectedOptions={chipOptions.filter((option) => option.value === state.sort)}
              distinctValues={[SortEnum.TYPE, SortEnum.CRITICALITY]}
              onChange={(value) => setSort(value[0] as SortEnum)}
            />
          </HStack>
        </HStack>
        <ScrollArea>
          <VStack padding={3} width="100%" height="100%" alignItems="start" gap={2}>
            {state.sort === SortEnum.CRITICALITY ? <CriticalityList /> : <TypeList />}
          </VStack>
        </ScrollArea>
      </VStack>
    </HStack>
  );
}
